/**
 * @generated SignedSource<<d984bdb39cd3348ceb23aefda1f5ba3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectsFilter_sheets$data = ReadonlyArray<{
  readonly surveyMeta: ReadonlyArray<{
    readonly key: string;
    readonly value: number;
  }>;
  readonly " $fragmentType": "ProjectsFilter_sheets";
}>;
export type ProjectsFilter_sheets$key = ReadonlyArray<{
  readonly " $data"?: ProjectsFilter_sheets$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsFilter_sheets">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProjectsFilter_sheets",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DataSheetSurveyMeta",
      "kind": "LinkedField",
      "name": "surveyMeta",
      "plural": true,
      "selections": [
        {
          "alias": "key",
          "args": null,
          "kind": "ScalarField",
          "name": "originalKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DataSheet",
  "abstractKey": null
};

(node as any).hash = "14b99aaad46332c1906ed76d1986164f";

export default node;
